import Component from './FactoryResetInstructions'

export default Component
